
// import React from 'react';

// const About = () => {
//   return (
//     <section id="about" className="py-16 px-6 bg-gray-100 text-gray-800">
//       <div className="max-w-4xl mx-auto">
        
//         {/* Heading */}
//         <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
//           About Me
//         </h2>

//         {/* Intro */}
//         <p className="text-md md:text-lg text-center mb-10">
//           I'm a <strong>Java Full Stack Developer</strong> with 3+ years of experience building scalable backend systems and high-performance web applications. 
//           I specialize in Spring Boot, REST APIs, and database design, helping businesses create secure and efficient solutions.
//         </p>

//         {/* Skills */}
//         <h3 className="text-2xl font-semibold text-indigo-600 mb-6 text-center">
//           Technical Skills
//         </h3>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm md:text-base text-gray-700">
          
//           <div>
//             <p><strong>Languages:</strong> Java (Core + OOP + DSA), JavaScript, SQL</p>
//             <p><strong>Backend:</strong> Spring Boot, Spring Security, JPA, Hibernate, Microservices</p>
//             <p><strong>Frontend:</strong> HTML, CSS, React.js</p>
//             <p><strong>UI/UX:</strong> Figma, Adobe XD</p>
//           </div>

//           <div>
//             <p><strong>Database:</strong> MySQL, PostgreSQL, MongoDB</p>
//             <p><strong>Tools:</strong> Git, GitHub, Docker, Jenkins, Postman, Swagger</p>
//             <p><strong>Cloud:</strong> AWS (EC2, S3), GCP (Basics)</p>
//             <p><strong>Other:</strong> REST APIs, JWT Auth, Agile/Scrum</p>
//           </div>

//         </div>

//         {/* Why Hire Me */}
//         <div className="mt-12 text-center">
//           <h3 className="text-2xl font-semibold text-indigo-600 mb-4">
//             Why Hire Me
//           </h3>

//           <ul className="space-y-2 text-gray-700">
//             <li>✔ Clean & scalable backend architecture</li>
//             <li>✔ Fast and efficient API development</li>
//             <li>✔ Strong problem-solving skills</li>
//             <li>✔ Reliable & on-time delivery</li>
//             <li>✔ Clear communication with clients</li>
//           </ul>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default About;

import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-16 px-6 bg-gray-100 text-gray-800">
      <div className="max-w-4xl mx-auto">
        
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          About Me
        </h2>

        {/* Intro */}
        <p className="text-md md:text-lg text-center mb-10">
          I'm a <strong>Java Full Stack Developer</strong> with 3+ years of experience building scalable backend systems and modern web applications. 
          I help businesses and startups develop fast, secure, and user-friendly applications using technologies like <strong>Spring Boot, React, and REST APIs</strong>.
        </p>

        {/* Skills */}
        <h3 className="text-2xl font-semibold text-indigo-600 mb-6 text-center">
          Technical Skills
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm md:text-base text-gray-700">
          
          <div>
            <p><strong>Languages:</strong> Java (Core, OOP, DSA), JavaScript, SQL</p>
            <p><strong>Backend:</strong> Spring Boot, Spring Security, JPA, Hibernate, Microservices</p>
            <p><strong>Frontend:</strong> React.js, HTML, CSS</p>
            <p><strong>UI/UX:</strong> Figma, Adobe XD</p>
          </div>

          <div>
            <p><strong>Database:</strong> MySQL, PostgreSQL, MongoDB</p>
            <p><strong>Tools:</strong> Git, GitHub, Docker, Jenkins, Postman, Swagger</p>
            <p><strong>Cloud:</strong> AWS (EC2, S3), GCP (Basics)</p>
            <p><strong>Other:</strong> REST APIs, JWT Auth, Agile/Scrum</p>
          </div>

        </div>

        {/* What I Do */}
        <div className="mt-12 text-center">
          <h3 className="text-2xl font-semibold text-indigo-600 mb-4">
            What I Do
          </h3>

          <ul className="space-y-2 text-gray-700">
            <li>✔ Build scalable backend systems & REST APIs</li>
            <li>✔ Develop responsive and modern frontend interfaces</li>
            <li>✔ Create full stack web applications end-to-end</li>
            <li>✔ Optimize performance and database design</li>
          </ul>
        </div>

        {/* Why Hire Me */}
        <div className="mt-10 text-center">
          <h3 className="text-2xl font-semibold text-indigo-600 mb-4">
            Why Hire Me
          </h3>

          <ul className="space-y-2 text-gray-700">
            <li>✔ Clean, maintainable & scalable code</li>
            <li>✔ Fast and reliable delivery</li>
            <li>✔ Strong problem-solving mindset</li>
            <li>✔ Clear communication & understanding of requirements</li>
            <li>✔ Experience working on real-world projects</li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default About;